const getters = {
  teamById: state => teamId => {
    return state.teams.find(x => x.teamId === teamId)
  },
}

export default getters
